
import { CalendarEvent, CalendarSource } from '@/types/calendar';
import { addDays, addHours, setHours, setMinutes } from 'date-fns';

// Helper function to create a date at a specific time
const createDate = (dayOffset: number, hours: number, minutes: number = 0): Date => {
  const date = addDays(new Date(), dayOffset);
  return setMinutes(setHours(date, hours), minutes);
};

// Mock calendar sources
export const mockSources: CalendarSource[] = [
  {
    id: 'local',
    name: 'My Calendar',
    type: 'local',
    color: 'bg-purple-500',
    isConnected: true,
    isVisible: true,
  },
  {
    id: 'google',
    name: 'Google Calendar',
    type: 'google',
    color: 'bg-blue-500',
    isConnected: false,
    isVisible: true,
  },
  {
    id: 'apple',
    name: 'Apple Calendar',
    type: 'apple',
    color: 'bg-gray-500',
    isConnected: false,
    isVisible: true,
  },
];

// Mock calendar events
export const mockEvents: CalendarEvent[] = [
  // Today's events
  {
    id: 'event1',
    title: 'Recording Session',
    description: 'Vocal recording for new single',
    start: createDate(0, 10, 0),
    end: createDate(0, 13, 0),
    location: 'Sunset Sound Studios',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
    attendees: [
      { email: 'producer@example.com', name: 'John Producer', status: 'accepted' },
      { email: 'engineer@example.com', name: 'Sound Engineer', status: 'accepted' },
    ],
  },
  {
    id: 'event2',
    title: 'Meeting with Manager',
    description: 'Discuss upcoming tour dates',
    start: createDate(0, 15, 0),
    end: createDate(0, 16, 0),
    location: 'Zoom Call',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  
  // Tomorrow's events
  {
    id: 'event3',
    title: 'Interview with Music Blog',
    description: 'Promoting new album release',
    start: createDate(1, 11, 30),
    end: createDate(1, 12, 30),
    location: 'Phone Call',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  
  // Events in the coming days
  {
    id: 'event4',
    title: 'Album Photoshoot',
    description: 'With photographer Alex Smith',
    start: createDate(3, 13, 0),
    end: createDate(3, 17, 0),
    location: 'Downtown Studio',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  {
    id: 'event5',
    title: 'Rehearsal',
    description: 'Prepare for weekend show',
    start: createDate(4, 14, 0),
    end: createDate(4, 18, 0),
    location: 'Rehearsal Space',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  {
    id: 'event6',
    title: 'Live Performance',
    description: 'Opening for Main Act',
    start: createDate(6, 20, 0),
    end: createDate(6, 22, 0),
    location: 'The Roxy Theater',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  
  // Further future events
  {
    id: 'event7',
    title: 'Music Video Shoot',
    description: 'For new single release',
    start: createDate(10, 9, 0),
    end: createDate(10, 19, 0),
    location: 'Venice Beach',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
  {
    id: 'event8',
    title: 'Radio Appearance',
    description: 'Live interview and acoustic performance',
    start: createDate(14, 10, 0),
    end: createDate(14, 11, 30),
    location: 'KCRW Studios',
    calendarId: 'local',
    source: 'local',
    color: 'bg-purple-500',
  },
];
